<div id="wait" *ngIf="isLoading == 1">
  <mat-spinner></mat-spinner>
</div>

<!-- Dropdown header: click to show/hide graphs and cards -->
<div class="nutrition-dropdown-header row mt-3 score-align-row" (click)="toggleNutritionDetails()" role="button" tabindex="0" (keydown.enter)="toggleNutritionDetails()" (keydown.space)="toggleNutritionDetails(); $event.preventDefault()">
  <div class="col-auto d-flex align-items-center">
    <span class="nutrition-dropdown-arrow" [class.expanded]="nutritionDetailsExpanded" aria-hidden="true"></span>
    <p class="mtitle mb-0 ms-2">Nutrition graphs &amp; cards (Calorie macros, percentage, eating pattern)</p>
  </div>
</div>

<!-- Collapsible content: calorie macros graph, percentage graph, macro cards, eating pattern graph, percentage graph, eating pattern cards -->
<div class="nutrition-dropdown-content" *ngIf="nutritionDetailsExpanded">
  <!-- Calories Macros Graph -->
  <div class="row mt-3 score-align-row">
    <div class="col-auto">
      <p class="mtitle mb-0">Select Metric to view trends (Multi-select for making comparison)</p>
    </div>
  </div>

  <div class="row mt-1">
    <div class="col-md-12">
      <label class="radioOpt">
        <input class="square-radio" type="checkbox" id="calories" 
          [(ngModel)]="selectedMacros['calories']" (change)="onMacroToggle('calories')" [checked]="selectedMacros['calories']"> Calories
      </label>
      <label class="radioOpt">
        <input class="square-radio" type="checkbox" id="protein" 
          [(ngModel)]="selectedMacros['protein']" (change)="onMacroToggle('protein')"> Protein
      </label>
      <label class="radioOpt">
        <input class="square-radio" type="checkbox" id="carbs" 
          [(ngModel)]="selectedMacros['carbs']" (change)="onMacroToggle('carbs')"> Carbs
      </label>
      <label class="radioOpt">
        <input class="square-radio" type="checkbox" id="fats" 
          [(ngModel)]="selectedMacros['fats']" (change)="onMacroToggle('fats')"> Fats
      </label>
    </div>
  </div>

  <div class="chart-container" style="width: 90%;" *ngIf="showChart1">
    <highcharts-chart #chart1 [Highcharts]="Highcharts"
      [options]="chartOptions1"
      [(update)]="updateFlag" [oneToOne]="oneToOneFlag" [runOutsideAngular]="runOutsideAngular"
      style="width: 100%; height: 100%; display: block;"></highcharts-chart>
  </div>

  <!-- Calories Macros Percentage Graph -->
  <div class="chart-container mt-5" style="width: 90%;" *ngIf="showChart3">
    <highcharts-chart #chart3 [Highcharts]="Highcharts"
      [options]="chartOptions3"
      [(update)]="updateFlag" [oneToOne]="oneToOneFlag" [runOutsideAngular]="runOutsideAngular"
      style="width: 100%; height: 100%; display: block;"></highcharts-chart>
  </div>

  <!-- Macros Cards -->
  <div class="col-md-12 flex mt-5" *ngIf="isLoading == 2" style="margin-top: 3rem !important;">
    <div class="col">
      <div class="gridSub">
        <div class="col-md-12">
          <img src="/assets/img/memberdashboard/nutri1.png"/>
        </div>
        <div class="col-md-12 mt-3 gridTitle">
          <div><span>Calories Percentage</span><span style="margin-left: 56px;">{{getCaloriesPercentage() !== null ? getCaloriesPercentage() + '%' : '---'}}</span></div>
          <p>
            <mat-progress-bar mode="determinate" [value]="getCaloriesPercentage() || 0" class="mt-3"></mat-progress-bar>
          </p>
        </div>
        <div class="col-md-12 mt-2">
          <div class="desc">Overall Calories taken: {{getCaloriesAverage() !== null ? getCaloriesAverage() + ' cal' : '---'}}</div>
        </div>
        <div class="col-md-12 mt-2">
          <div class="goal">Goal: {{getCaloriesGoal() !== null ? getCaloriesGoal() + ' cal' : '---'}}</div>
        </div>
      </div>
    </div>
    <div class="col">
      <div class="gridSub">
        <div class="col-md-12">
          <img src="/assets/img/memberdashboard/nutri2.png"/>
        </div>
        <div class="col-md-12 mt-3 gridTitle">
          <div><span>Protein Percentage</span><span style="margin-left: 56px;">{{getProteinPercentage() !== null ? getProteinPercentage() + '%' : '---'}}</span></div>
          <p>
            <mat-progress-bar mode="determinate" [value]="getProteinPercentage() || 0" class="mt-3"></mat-progress-bar>
          </p>
        </div>
        <div class="col-md-12 mt-2">
          <div class="desc">Overall Protein taken: {{getProteinAverage() !== null ? getProteinAverage() + ' cal' : '---'}}</div>
        </div>
        <div class="col-md-12 mt-2">
          <div class="goal">Goal: {{getProteinGoal() !== null ? getProteinGoal() + ' cal' : '---'}}</div>
        </div>
      </div>
    </div>
    <div class="col">
      <div class="gridSub">
        <div class="col-md-12">
          <img src="/assets/img/memberdashboard/nutri3.png"/>
        </div>
        <div class="col-md-12 mt-3 gridTitle">
          <div><span>Carbs Percentage</span><span style="margin-left: 56px;">{{getCarbsPercentage() !== null ? getCarbsPercentage() + '%' : '---'}}</span></div>
          <p>
            <mat-progress-bar mode="determinate" [value]="getCarbsPercentage() || 0" class="mt-3"></mat-progress-bar>
          </p>
        </div>
        <div class="col-md-12 mt-2">
          <div class="desc">Overall Carbs taken: {{getCarbsAverage() !== null ? getCarbsAverage() + ' cal' : '---'}}</div>
        </div>
        <div class="col-md-12 mt-2">
          <div class="goal">Goal: {{getCarbsGoal() !== null ? getCarbsGoal() + ' cal' : '---'}}</div>
        </div>
      </div>
    </div>
    <div class="col">
      <div class="gridSub">
        <div class="col-md-12">
          <img src="/assets/img/memberdashboard/nutri4.png" class="fat-icon"/>
        </div>
        <div class="col-md-12 mt-3 gridTitle">
          <div><span>Fats Percentage</span><span style="margin-left: 56px;">{{getFatsPercentage() !== null ? getFatsPercentage() + '%' : '---'}}</span></div>
          <p>
            <mat-progress-bar mode="determinate" [value]="getFatsPercentage() || 0" class="mt-3"></mat-progress-bar>
          </p>
        </div>
        <div class="col-md-12 mt-2">
          <div class="desc">Overall Fats taken: {{getFatsAverage() !== null ? getFatsAverage() + ' cal' : '---'}}</div>
        </div>
        <div class="col-md-12 mt-2">
          <div class="goal">Goal: {{getFatsGoal() !== null ? getFatsGoal() + ' cal' : '---'}}</div>
        </div>
      </div>
    </div>
  </div>

  <br />

  <!-- Eating Pattern Graph -->
  <div class="row mt-3 score-align-row">
    <div class="col-auto">
      <p class="mtitle mb-0">Select Meal to view trends (Multi-select for making comparison)</p>
    </div>
  </div>

  <div class="row mt-1">
    <div class="col-md-12">
      <label class="radioOpt">
        <input class="square-radio" type="checkbox" id="breakfast" 
          [(ngModel)]="selectedMeals['breakfast']" (change)="onMealToggle('breakfast')" [checked]="selectedMeals['breakfast']"> Breakfast
      </label>
      <label class="radioOpt">
        <input class="square-radio" type="checkbox" id="lunch" 
          [(ngModel)]="selectedMeals['lunch']" (change)="onMealToggle('lunch')"> Lunch
      </label>
      <label class="radioOpt">
        <input class="square-radio" type="checkbox" id="dinner" 
          [(ngModel)]="selectedMeals['dinner']" (change)="onMealToggle('dinner')"> Dinner
      </label>
      <label class="radioOpt">
        <input class="square-radio" type="checkbox" id="snacks" 
          [(ngModel)]="selectedMeals['snacks']" (change)="onMealToggle('snacks')"> Snacks
      </label>
    </div>
  </div>

  <div class="chart-container" style="width: 90%;" *ngIf="showChart2">
    <highcharts-chart #chart2 [Highcharts]="Highcharts"
      [options]="chartOptions2"
      [(update)]="updateFlag" [oneToOne]="oneToOneFlag" [runOutsideAngular]="runOutsideAngular"
      style="width: 100%; height: 100%; display: block;"></highcharts-chart>
  </div>

  <!-- Eating Pattern Percentage Graph -->
  <div class="chart-container mt-5" style="width: 90%;" *ngIf="showChart4">
    <highcharts-chart #chart4 [Highcharts]="Highcharts"
      [options]="chartOptions4"
      [(update)]="updateFlag" [oneToOne]="oneToOneFlag" [runOutsideAngular]="runOutsideAngular"
      style="width: 100%; height: 100%; display: block;"></highcharts-chart>
  </div>

  <!-- Eating Pattern Cards -->
  <div class="col-md-12 flex mt-5" *ngIf="isLoading == 2" style="margin-top: 3rem !important;">
    <div class="col">
      <div class="gridSub">
        <div class="col-md-12">
          <img src="/assets/img/memberdashboard/eat1.png"/>
        </div>
        <div class="col-md-12 mt-3 gridTitle">
          <div><span>Breakfast</span><span style="margin-left: 100px;">{{getBreakfastPercentage() !== null ? getBreakfastPercentage() + '%' : '---'}}</span></div>
          <p>
            <mat-progress-bar mode="determinate" [value]="getBreakfastPercentage() || 0" class="mt-3"></mat-progress-bar>
          </p>
        </div>
        <div class="col-md-12 mt-2">
          <div class="desc">Overall Calories taken: {{getBreakfastAverage() !== null ? getBreakfastAverage() + ' cal' : '---'}}</div>
        </div>
        <div class="col-md-12 mt-2">
          <div class="goal">Goal: {{getBreakfastGoal() !== null ? getBreakfastGoal() + ' cal' : '---'}}</div>
        </div>
      </div>
    </div>
    <div class="col">
      <div class="gridSub">
        <div class="col-md-12">
          <img src="/assets/img/memberdashboard/eat2.png"/>
        </div>
        <div class="col-md-12 mt-3 gridTitle">
          <div><span>Lunch</span><span style="margin-left: 100px;">{{getLunchPercentage() !== null ? getLunchPercentage() + '%' : '---'}}</span></div>
          <p>
            <mat-progress-bar mode="determinate" [value]="getLunchPercentage() || 0" class="mt-3"></mat-progress-bar>
          </p>
        </div>
        <div class="col-md-12 mt-2">
          <div class="desc">Overall Calories taken: {{getLunchAverage() !== null ? getLunchAverage() + ' cal' : '---'}}</div>
        </div>
        <div class="col-md-12 mt-2">
          <div class="goal">Goal: {{getLunchGoal() !== null ? getLunchGoal() + ' cal' : '---'}}</div>
        </div>
      </div>
    </div>
    <div class="col">
      <div class="gridSub">
        <div class="col-md-12">
          <img src="/assets/img/memberdashboard/eat3.png"/>
        </div>
        <div class="col-md-12 mt-3 gridTitle">
          <div><span>Dinner</span><span style="margin-left: 100px;">{{getDinnerPercentage() !== null ? getDinnerPercentage() + '%' : '---'}}</span></div>
          <p>
            <mat-progress-bar mode="determinate" [value]="getDinnerPercentage() || 0" class="mt-3"></mat-progress-bar>
          </p>
        </div>
        <div class="col-md-12 mt-2">
          <div class="desc">Overall Calories taken: {{getDinnerAverage() !== null ? getDinnerAverage() + ' cal' : '---'}}</div>
        </div>
        <div class="col-md-12 mt-2">
          <div class="goal">Goal: {{getDinnerGoal() !== null ? getDinnerGoal() + ' cal' : '---'}}</div>
        </div>
      </div>
    </div>
    <div class="col">
      <div class="gridSub">
        <div class="col-md-12">
          <img src="/assets/img/memberdashboard/eat3.png"/>
        </div>
        <div class="col-md-12 mt-3 gridTitle">
          <div><span>Snacks</span><span style="margin-left: 100px;">{{getSnacksPercentage() !== null ? getSnacksPercentage() + '%' : '---'}}</span></div>
          <p>
            <mat-progress-bar mode="determinate" [value]="getSnacksPercentage() || 0" class="mt-3"></mat-progress-bar>
          </p>
        </div>
        <div class="col-md-12 mt-2">
          <div class="desc">Overall Calories taken: {{getSnacksAverage() !== null ? getSnacksAverage() + ' cal' : '---'}}</div>
        </div>
        <div class="col-md-12 mt-2">
          <div class="goal">Goal: {{getSnacksGoal() !== null ? getSnacksGoal() + ' cal' : '---'}}</div>
        </div>
      </div>
    </div>
  </div>
</div>
